var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('div',[_c('LoginMovil')],1):_c('div',[_c('LoginWeb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }